"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = CalendarCheckColor;

var _CalendarCheckColor = require("@adobe/react-spectrum-workflow-color/dist/CalendarCheckColor");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function CalendarCheckColor(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_CalendarCheckColor.A4uCalendarCheckColor, null));
}